<template>
    <page>
        <h1>Schadensmeldung</h1>
        <!-- <slider currentPage="schadensmeldung" /> -->
        <ion-card>
            <ion-grid>
                <ion-row class="ion-align-items-center">
                    <ion-col class="ion-margin-bottom">
                        <h4 class="ion-no-margin">Carglass<sup>®</sup></h4>
                        <div>Dein Spezialist für Fahrzeugglas</div>
                        <br />
                        <h4 class="ion-no-margin">Exklusiv: MO'Drive</h4>
                        <div>Kostenloses Rundum-Reparaturservice</div>
                    </ion-col>
                    <ion-col size="12" size-sm class="ion-no-padding">
                        <img
                            :src="`${baseurl}/content/dam/klickmal/me1ns/images/kamel_modrive_carglass.png`"
                            height="170"
                            style="width: auto; margin: auto;"
                        />
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-card>
        <expansion-card v-if="$store.state.isLoggedIn">
            <template v-slot:header>
                <b
                    >Im Schadensfall soll´s schnell gehen. Melde uns deinen
                    Schaden schnell und bequem über das jeweilige Formular.</b
                >
            </template>
            Die erfassten Daten werden an die zuständige Abteilung gesendet und
            dort weiter verarbeitet. Bei Fragen, wende dich bitte an unsere
            <a href="tel:+4357070510" @click.stop>Schadenshotline</a>.
        </expansion-card>
        <expansion-card v-else>
            <template v-slot:header>
                <b
                    >Einige wichtige Dinge, die du bei deiner Schadensmeldung
                    beachten solltest!</b
                >
            </template>
            Die erfassten Daten werden an die zuständige Abteilung gesendet und
            dort weiter verarbeitet. Bei Fragen, wende dich bitte an unsere
            <a href="tel:+4357070510">Schadenshotline</a>.
        </expansion-card>
        <ion-grid>
            <ion-row>
                <ion-col size="4">
                    <pagelink
                        :path="{ name: 'schadensmeldung-kfz' }"
                        icon="flame"
                        title="KFZ"
                    />
                </ion-col>
                <ion-col size="4">
                    <pagelink
                        :path="{ name: 'schadensmeldung-haushalt' }"
                        icon="flame"
                        title="Haushalt & Eigenheim"
                    />
                </ion-col>
                <ion-col size="4">
                    <pagelink
                        :path="{ name: 'schadensmeldung-sach' }"
                        icon="flame"
                        title="Sachvers. Unwetter"
                    />
                </ion-col>
                <ion-col size="4">
                    <pagelink
                        :path="{ name: 'schadensmeldung-recht' }"
                        icon="flame"
                        title="Rechtsschutz"
                    />
                </ion-col>
            </ion-row>
        </ion-grid>
        <div class="ion-padding-top u-size-small">
            <p>
                Die von Ihnen im Rahmen der Online-Schadenmeldung offengelegten
                Informationen werden von uns (Wüstenrot Versicherungs-AG) zum
                Zweck der Bearbeitung und Abwicklung eines Versicherungsfalles
                (gemäß Art 6 Abs 1 lit b DSGVO) verarbeitet. Informationen
                betreffend den konkreten Versicherungsfall werden etwaigen
                Beteiligten bzw. Auskunftspersonen nur insoweit offengelegt,
                soweit dies für die Bearbeitung des Versicherungsfalles
                unbedingt erforderlich ist.
            </p>
            <p>
                Weitere Informationen zum Datenschutz, insbesondere zu den
                Betroffenenrechten (Recht auf Auskunft, Berichtigung, Löschung,
                Einschränkung der Verarbeitung, Widerspruch und
                Datenübertragbarkeit), finden Sie unter
                <a href="http://www.wuestenrot.at/datenschutz" target="_blank"
                    >Datenschutz</a
                >.
            </p>
        </div>
    </page>
</template>

<script>
import Page from "@/components/Page";
import Pagelink from "@/components/Pagelink";
import ExpansionCard from "@/components/ExpansionCard";
import { BASEURL } from "@/utils/globals";
// import Slider from "@/components/Slider";

export default {
    components: { Page, Pagelink, ExpansionCard },
    data() {
        return {
            baseurl: BASEURL,
        };
    },
};
</script>

<style></style>
